import { LinksSchemaType } from "../type";

export const domFlightLinksArray: LinksSchemaType = {
  main: "/flights",
  maintitle: "همه پروازهای داخلی",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/flight-dom-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/flight-dom-mobile.png`,
  otherlinks: [
    {
      title: "پرواز تهران مشهد",
      href: "/flights/THR_city/MHD_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-mashhad.png`
    },
    {
      title: "پرواز مشهد تهران",
      href: "/flights/MHD_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad-tehran.png`
    },
    {
      title: "پرواز تهران شیراز",
      href: "/flights/THR_city/SYZ_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-shiraz.png`
    },
    {
      title: "پرواز شیراز تهران",
      href: "/flights/SYZ_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/shiraz-tehran.png`
    },
    {
      title: "پرواز تهران اهواز",
      href: "/flights/THR_city/AWZ_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-ahvaz.png`
    },
    {
      title: "پرواز اهواز تهران",
      href: "/flights/AWZ_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/ahvaz-tehran.png`
    },
    {
      title: "پرواز تهران کیش",
      href: "/flights/THR_city/KIH_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-kish.png`
    },
    {
      title: "پرواز کیش تهران",
      href: "/flights/KIH_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/kish-tehran.png`
    },
    {
      title: "پرواز تهران تبریز",
      href: "/flights/THR_city/TBZ_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-tabriz.png`
    },
    {
      title: "پرواز تبریز تهران",
      href: "/flights/TBZ_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tabriz-tehran.png`
    },
    {
      title: "پرواز تهران بندرعباس",
      href: "/flights/THR_city/BND_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-bandarabbas.png`
    },
    {
      title: "پرواز بندرعباس تهران",
      href: "/flights/BND_city/THR_city",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/bandarabbas-tehran.png`
    }
  ]
};
